module.exports = __webpack_public_path__ + "media/audio31.85adc4f7.mp3";